var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChangeRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 10,
    height: 1.5,
    fill: "#4C6CB7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 10,
    height: 1.5,
    fill: "#4C6CB7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 20,
    height: 16,
    rx: 0.5,
    stroke: "#4F74F9",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 18,
    height: 4,
    fill: "#4F74F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H27.5C27.7761 17 28 16.7761 28 16.5V1.5C28 1.22386 27.7761 1 27.5 1H8.5C8.22386 1 8 1.22386 8 1.5V5",
    stroke: "#828A9A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H27V2H8V5H22.8C23.4627 5 24 5.53726 24 6.2V16Z",
    fill: "#828A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeRole);
export default __webpack_public_path__ + "static/media/icon_change_role.79273a1b6f026a4bca80607d88a959ee.svg";
export { ForwardRef as ReactComponent };